// extracted by mini-css-extract-plugin
export default {"shellInformation":"Information_shellInformation__XTB74","emphasisText":"Information_emphasisText__XWcpo"};